module.exports = __webpack_public_path__ + "img/EDC5000DQ_R.a87b1b99.png";